import { Link } from "react-router-dom";

export const Monogram = ({ className = "h-10 w-10", light = false }) => (
  <svg viewBox="0 0 64 64" className={className} role="img" aria-label="C4X4 monogram">
    <rect width="64" height="64" rx="4" fill={light ? "#F7F4ED" : "#16352C"} />
    <rect x="4" y="4" width="56" height="56" rx="2" fill="none" stroke={light ? "#16352C" : "#DDD5C5"} strokeOpacity=".4" />
    <text x="32" y="27" textAnchor="middle" fontFamily="Cormorant Garamond, Georgia, serif" fontSize="17" letterSpacing="2" fill={light ? "#16352C" : "#F7F4ED"}>C</text>
    <text x="32" y="48" textAnchor="middle" fontFamily="Cormorant Garamond, Georgia, serif" fontSize="21" fontWeight="600" fill={light ? "#16352C" : "#F7F4ED"}>4×4</text>
  </svg>
);

export function Logo({ light = false, className = "" }) {
  const c = light ? "text-paper" : "text-forest";
  return (
    <Link to="/" data-testid="site-logo" aria-label="Cirencester 4x4 — home" className={`group flex flex-col ${className}`}>
      <span className="flex items-baseline gap-1.5 sm:gap-2.5">
        <span className={`text-[0.6rem] font-bold tracking-[0.2em] sm:text-[0.72rem] sm:tracking-[0.32em] ${light ? "text-paper" : "text-charcoal"}`}>CIRENCESTER</span>
        <span className={`font-serif text-[1.9rem] leading-[0.8] font-semibold tracking-tight sm:text-[2.35rem] ${c}`}>4×4</span>
      </span>
      <span className={`mt-1 hidden text-[0.58rem] tracking-[0.2em] uppercase sm:block ${light ? "text-stone" : "text-charcoal/70"}`}>Specialist 4x4 &amp; SUV Sales</span>
    </Link>
  );
}
